
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^((116|124|819)0|8486)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
